import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ApiResponse, IApiQueryOptions } from 'api/ApiClient';
import { IAcceptancePayment, IAction, IApiList, ITipAcceptancePaymentSetPayouts, ITipAcceptancePaymentSetRequestPayload } from 'types';
import { formatErrorMessages } from 'utils/errors';
import { calculatePaymentSetHoldbacks } from 'utils/payout';
import * as API from '../../api';
import * as Actions from './actions';
import { TipAcceptance } from './types';

export function* getPayments({ payload }: IAction<TipAcceptance, { siteId: string; options?: IApiQueryOptions }>) {
  try {
    const response: ApiResponse<IApiList<IAcceptancePayment>> = yield call(API.Sites.getTipAcceptancePayments, payload.siteId, payload.options);
    yield put(Actions.getPaymentsSuccess(response.body));
  } catch (error: any) {
    const formattedError = formatErrorMessages({ errors: error.body?.errors, statusCode: error.statusCode });
    yield put(Actions.getPaymentsError(formattedError));
  }
}

export function* getPaymentSet(action: IAction<TipAcceptance, { options: ITipAcceptancePaymentSetRequestPayload; onSuccess: (paymentSet: ITipAcceptancePaymentSetPayouts) => void }>) {
  try {
    const { options, onSuccess } = action.payload;
    const { siteId, paymentSetId, siteHoldbacks } = options || {};

    if (!siteId || !paymentSetId || !siteHoldbacks) throw new Error('payment information not found');

    const response: ApiResponse<ITipAcceptancePaymentSetPayouts> = yield call(API.Sites.getTipAcceptancePayouts, siteId, paymentSetId);

    const paymentSet = calculatePaymentSetHoldbacks(response.body, siteHoldbacks);

    if (onSuccess) yield call(onSuccess, paymentSet);

    yield put(Actions.getPaymentSetSuccess(paymentSet));
  } catch (error: any) {
    const formattedError = formatErrorMessages({ errors: error.body?.errors, statusCode: error.statusCode });
    yield put(Actions.getPaymentSetFail(formattedError));
  }
}

export function* watchGetPayments() {
  yield takeEvery(TipAcceptance.GET_PAYMENTS_REQUEST, getPayments);
}

export function* watchGetPaymentSet() {
  yield takeEvery(TipAcceptance.GET_PAYMENT_SET_REQUEST, getPaymentSet);
}

function* tipAcceptanceSaga() {
  yield all([fork(watchGetPayments), fork(watchGetPaymentSet)]);
}

export { tipAcceptanceSaga };
